function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome3L({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 287,
    height: 351,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#f4e2e2",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFECE7",
    d: "M200.11 63.327c-51.517 1.805-96.081 36.923-137.698 55.868-34.963 15.915 41.792-56.235 43.44-96.038 5.27-127.275-434.808 320.347-19.138 327.652 98.515 1.731 180.724-21.723 199.378-113.421 15.086-74.158-219.253 6.04-119.977-38.958 30.701-13.916 151.02-139.201 33.995-135.103Z",
    style: {
      fill: "#f4e2e2",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome3L);
export default __webpack_public_path__ + "static/media/bg_home3_l.44ebbc3e2550bf7f1db7bf3ba4b0dda6.svg";
export { ForwardRef as ReactComponent };